import * as React from "react"
import Layout from "../../components/layout/layout";

import weedmats from "../../images/products/agri/weedmats.jpg"
import cropcovers from "../../images/products/agri/cropcovers.jpg"
import plantcovers from "../../images/products/agri/plantcovers.jpg"
import landscape from "../../images/products/agri/landscape.jpg"

const AgriTechPage = () => {
    return (
        <Layout pageName={"Agri Tech"}>
            <div className="container justify-content-center align-items-center">
                <p
                    data-sal="slide-down"
                    data-sal-delay="100"
                    data-sal-easing="easeInExpo"
                    className="pb-10 lead fs-23 my-3"
                >
                    <i className="text-orange bi bi-arrow-right-short"/>
                    UV Stabilised, Air Permeable and Strong, Our Fabrics help in protecting
                    the soil and the crops. They help in keeping the soil nutrient rich and
                    avoid pests and harmful weeds.
                </p>
                <div className="pb-15 grid grid-view text-center">
                    <div className="row gx-md-8 gy-10 gy-md-13">
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="card lift">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={landscape} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Landscape Fabrics
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Up to 3.2m width
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                70 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Black
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                UV protected
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Air &amp; water permeable
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Folded fabric available in rolls
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Mini rolls &amp; jumbo rolls
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="card lift">
                                <figure className="card-img-top">
                                    <img className="img-fluid h-100" src={weedmats} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Weed Mats
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                1m, 2m, 3.2m
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                50 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Black
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                UV protected
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Air &amp; water permeable
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Folded fabric available in rolls
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Mini rolls &amp; jumbo rolls
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="card lift">
                                <figure className="card-img-top">
                                    <img className="img-fluid h-100" src={cropcovers} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Crop Covers
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                63”, 94”, 126”
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                17 GSM
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                UV stabilised
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                High strength
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 pt-6 d-flex align-items-stretch">
                            <div className="card lift">
                                <figure className="card-img-top">
                                    <img className="img-fluid" src={plantcovers} alt=""/>
                                </figure>
                                <div className="card-body px-6 py-5">
                                    <h4 className="mb-3">
                                        Plant & Tree Covers / Blankets
                                    </h4>
                                    <ul className="icon-list bullet-orange">
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Cut and sew to size
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                UV stabilised
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                Black, Green, Beige
                                            </span>
                                        </li>
                                        <li>
                                            <span>
                                                <i className="bi bi-arrow-right"/>
                                            </span>
                                            <span>
                                                With eyelets / drawstrings for easy covering &amp; removal
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default AgriTechPage